<div #container class="slider-container">
  <div #slider class="slider" [ngClass]="sliderClass()">
    <div class="slide" *ngFor="let slide of items; index as i" [style]="slideStyle()">
      <div [style]="slide.flex" class="slide-img">
<!--        <div *ngIf="isCloud(slide) && slide.cloud" class="slide-img-cloud"-->
<!--             [style]="'top: ' + slide.cloud.top + '%;' + 'left: ' + slide.cloud.left + '%;' + (slide.cloud.minWidthCloud ? 'min-width: ' + slide.cloud.minWidthCloud  + 'px' : '')">-->
<!--          <div class="slide-img-cloud-top">-->
<!--            <app-texts-->
<!--              [texts]="[-->
<!--                {text: slide.cloud.title, noWarp: true}-->
<!--              ]"-->
<!--            />-->
<!--            <div *ngIf="slide.cloud.link != undefined" class="slide-img-cloud-top-icon" (click)="openLink(slide.cloud.link)">-->
<!--&lt;!&ndash;              <img src="app/assets/icons/arrow-bold.svg" alt="arrow">&ndash;&gt;-->
<!--&lt;!&ndash;              <app-icon [icon]="Icons.arrowBold" [invert]="getInvert()"/>&ndash;&gt;-->
<!--              <img [src]="Icons.arrowBold.src" [style]="arrowWidth">-->
<!--&lt;!&ndash;              <app-icon [icon]="slide.cloud.button ?? Icons.default"/>&ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="slide-img-cloud-workspace" [style]="'padding-top: ' + (slide.cloud.paddingTop ?? 0) + 'px;'">-->
<!--            <div class="d-flex" [style]="topMargin" *ngIf="slide.cloud.icon1 != undefined">-->
<!--              &lt;!&ndash;                <app-icon [icon]="slide.cloud.icon1 ?? Icons.default" [invert]="getInvert()"/>&ndash;&gt;-->
<!--              <div class="slide-img-cloud-workspace-icon">-->
<!--                <img [src]="slide.cloud.icon1.src">-->
<!--              </div>-->
<!--              <span class="capitalize-words">-->
<!--                <app-texts [texts]="[-->
<!--                {text: [slide.cloud.textRu1 ?? '', slide.cloud.textEn1 ?? ''], noWarp: true}-->
<!--              ]"/>-->
<!--              </span>-->
<!--            </div>-->
<!--            <div class="d-flex" [style]="middleMargin" *ngIf="slide.cloud.icon2 != undefined">-->
<!--&lt;!&ndash;              <app-icon [icon]="slide.cloud.icon2 ?? Icons.default" [invert]="getInvert()"/>&ndash;&gt;-->
<!--              <div class="slide-img-cloud-workspace-icon">-->
<!--                <img [src]="slide.cloud.icon2.src">-->
<!--              </div>-->
<!--              <span class="capitalize-words">-->
<!--                <app-texts [texts]="[-->
<!--                {text: [slide.cloud.textRu2 ?? '', slide.cloud.textEn2 ?? ''], noWarp: true}-->
<!--              ]"/>-->
<!--              </span>-->
<!--            </div>-->
<!--            <div class="d-flex" *ngIf="slide.cloud.icon3 != undefined">-->
<!--&lt;!&ndash;              <app-icon [icon]="slide.cloud.icon3 ?? Icons.default" [invert]="getInvert()"/>&ndash;&gt;-->
<!--              <div class="slide-img-cloud-workspace-icon">-->
<!--                <img [src]="slide.cloud.icon3.src">-->
<!--              </div>-->
<!--              <span style="align-items: center;" class="capitalize-words">-->
<!--                <app-texts [texts]="[-->
<!--                {text: [slide.cloud.textRu3 ?? '', slide.cloud.textEn3 ?? ''], noWarp: true}-->
<!--              ]"/>-->
<!--              </span>-->
<!--            </div>-->
<!--            <span class="d-flex">-->
<!--              <app-texts [texts]="slide.cloud.text"/>-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
        <app-image-slider
          [card]="slide"
        />
      </div>
    </div>
  </div>
</div>

